import { render, staticRenderFns } from "./shareorder.vue?vue&type=template&id=a911856c&scoped=true&"
import script from "./shareorder.vue?vue&type=script&lang=js&"
export * from "./shareorder.vue?vue&type=script&lang=js&"
import style0 from "./shareorder.vue?vue&type=style&index=0&id=a911856c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a911856c",
  null
  
)

export default component.exports